<template>
  <div class="tkc-gallery" :data-index="proxyIndex" :data-max-index="maxIndex">
    <div class="gallery-wrap" :style="wrapStyles">
      <div class="gallery-view" :style="viewStyles">
        <slot></slot>
      </div>
    </div>
    <div
      v-if="maxIndex > 0"
      class="gallery-button"
      :class="prevButtonClasses"
      :style="prevStyles"
      @click="slideToPrev"
    >
      <i class="gallery-button-icon is-prev">
        <svg class="cusicon-icon" aria-hidden="true">
          <use xlink:href="#cusicon-left" />
        </svg>
      </i>
    </div>
    <div
      v-if="maxIndex > 0"
      class="gallery-button"
      :class="nextButtonClasses"
      :style="nextStyles"
      @click="slideToNext"
    >
      <i class="gallery-button-icon is-next">
        <svg class="cusicon-icon" aria-hidden="true">
          <use xlink:href="#cusicon-right" />
        </svg>
      </i>
    </div>
  </div>
</template>

<script>
  import vueUtils from '../../../utils/vue_utils';
  const DEFAULT_INDEX = 0;
  const DEFAULT_WIDTH = 600;
  const DEFAULT_BUTTON_POS = 32;
  const ICON_SIZE = 'default';

  export default {
    name: 'GalleryComponent',
    props: vueUtils.initDefaultProps(
      {
        wrapWidth: Number,
        viewWidth: Number,
        prevLeft: Number,
        nextRight: Number,
        iconSize: String,
        defaultIndex: Number,
      },
      {
        wrapWidth: DEFAULT_WIDTH,
        viewWidth: DEFAULT_WIDTH,
        prevLeft: DEFAULT_BUTTON_POS,
        nextRight: DEFAULT_BUTTON_POS,
        iconSize: ICON_SIZE,
        defaultIndex: DEFAULT_INDEX,
      },
    ),
    data() {
      return {
        index: this.defaultIndex,
      };
    },
    computed: {
      prevStyles() {
        return { left: '-' + this.prevLeft + 'px' };
      },
      nextStyles() {
        return { right: '-' + this.nextRight + 'px' };
      },
      wrapStyles() {
        return { width: this.wrapWidth + 'px' };
      },
      viewStyles() {
        const marginLeft = this.proxyIndex * this.wrapWidth;
        const maxMarginLeft = this.viewWidth - this.wrapWidth;

        const _marginLeft = marginLeft > maxMarginLeft ? maxMarginLeft : marginLeft;

        return {
          width: this.viewWidth + 'px',
          'margin-left': '-' + _marginLeft + 'px',
        };
      },
      maxIndex() {
        return Math.ceil(this.viewWidth / this.wrapWidth) - 1;
      },
      minIndex() {
        return 0;
      },
      // 计算属性代理index, 实现有范围的自动取值
      proxyIndex: {
        get() {
          return this.index;
        },
        set(index) {
          const maxIndex = this.maxIndex;
          const minIndex = this.minIndex;

          this.index = index > maxIndex ? maxIndex : index < minIndex ? minIndex : index;
        },
      },
      prevButtonClasses() {
        const classes = {};
        classes['gallery-button-' + this.iconSize] = true;
        classes['is-disabled'] = this.proxyIndex == this.minIndex;
        return classes;
      },
      nextButtonClasses() {
        const classes = {};
        classes['gallery-button-' + this.iconSize] = true;
        classes['is-disabled'] = this.proxyIndex == this.maxIndex;
        return classes;
      },
    },
    created() {
      this.$bus?.$on('slide-to-first', this.slideToFirst);
      this.$bus?.$on('slide-to-prev', this.slideToPrev);
      this.$bus?.$on('slide-to-next', this.slideToNext);
      this.$bus?.$on('slide-to-last', this.slideToLast);
    },
    methods: {
      slideToPrev() {
        this.proxyIndex--;
      },
      slideToNext() {
        this.proxyIndex++;
      },
      slideToLast() {
        this.proxyIndex = this.maxIndex;
      },
      slideToFirst() {
        this.proxyIndex = this.minIndex;
      },
    },
  };
</script>

<style lang="less">
  @import '../../../themes';
  .tkc-gallery {
    position: relative;
  }

  .tkc-gallery .gallery-wrap {
    overflow: hidden;
  }

  .tkc-gallery .gallery-view {
    transition: margin 0.5s ease;
  }

  .tkc-gallery .gallery-button {
    position: absolute;
    cursor: pointer;
    &.is-disabled {
      cursor: no-drop;
      &,
      &:hover {
        .gallery-button-icon {
          color: #e6e6e6;
        }
      }
    }
    &:hover {
      .gallery-button-icon {
        color: @primary-color;
      }
    }
  }

  .tkc-gallery {
    .gallery-button-default {
      width: 42px;
      height: 42px;
      top: 50%;
      margin-top: -20px;
    }
    .gallery-button-small {
      width: 16px;
      height: 20px;
      top: 50%;
      margin-top: -10px;
    }
  }

  .gallery-button-icon {
    display: inline-block;
    width: 100%;
    height: 100%;
    color: #666;
    .cusicon-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      fill: currentColor;
      overflow: hidden;
    }
  }
</style>
